// extracted by mini-css-extract-plugin
module.exports = {"icon":"Map_icon__1w7IQ","closedList":"Map_closedList__3xguy","openedList":"Map_openedList__1HCCc"};